import PosterTransition from 'components/poster-transition/poster-transition';
import FreeSpinsRecord from 'integration/freespin-record';
import { BounceZoomIn, FadeIn } from 'slotworks/graphics/animation/base-animations';
import Layers from 'slotworks/graphics/layers/layers';
import { AbstractSceneTransition } from 'slotworks/graphics/layers/scene-transitions/abstract-scene-transition';
import GameState from 'slotworks/model/game-state';
import Contract from 'slotworks/utils/contract';
import { sequence } from 'slotworks/utils/race-utils';
import * as TweenJS from 'slotworks/utils/tween';
import deviceInfo from 'slotworks/utils/device-info';
import PortraitMessages from 'components/messages/portrait-messages';
import Components from 'slotworks/components/components';

export default class EnterFreeSpinTransition extends AbstractSceneTransition {
    private BOUNCE_TIME: number = 600;
    private glow: PIXI.Sprite;

    public in(): Contract<void> {
        return new Contract(resolve => {
            FadeIn(Layers.CelebrationBackground.getSprite('filter'), 400).execute();
            this.glow = Layers.CelebrationBackground.getSprite('DO_glow');
            this.glow.anchor.set(0.5, 0.5);
            this.glow.x += this.glow.width / 2;
            this.glow.y += this.glow.height / 2;
            const rotation = Math.PI / 64;
            this.glow.rotation = -rotation;

            BounceZoomIn(this.glow, this.BOUNCE_TIME).execute();
            BounceZoomIn(Layers.Prompts.container, this.BOUNCE_TIME).then(() => {
                new TweenJS.Tween(this.glow)
                    .to({ rotation }, 2000)
                    .repeat(Infinity)
                    .yoyo(true)
                    .start();
                new TweenJS.Tween(this.glow)
                    .to({ alpha: 0.6 }, 200)
                    .repeat(Infinity)
                    .delay(100)
                    .yoyo(true)
                    .start();
            });
            resolve(null);
            this.setValues();

            if(!deviceInfo.isDesktop) {
                deviceInfo.onLayoutChange.add(this.onLayoutChange);
            }
        });
    }

    private onLayoutChange = () => {
        const position = Layers.CelebrationBackground.getPosition("DO_glow");
        this.glow.position.set(position.x + position.width/2, position.y + position.height/2);
    }

    private setValues() {
        const value = Layers.Prompts.getBitmapText('value');
        const record = GameState.getCurrentGame().getCurrentRecord();
        const r = record.getResultsOfType(FreeSpinsRecord) as FreeSpinsRecord[];
        const freeSpinRecord = r[0];
        if (value) value.text = freeSpinRecord && freeSpinRecord.freespinsWon ? freeSpinRecord.freespinsWon.toString() : record.freespinsWon.toString();
    }

    public out(): Contract<void> {
        if(!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.remove(this.onLayoutChange);
        }        
        Components.matrix.idleSymbols();
        TweenJS.removeAll(this.glow);
        return sequence([
            () => PosterTransition.start(),
            () =>
                Contract.wrap(() => {
                    Layers.Prompts.container.children.map(el => (el.visible = false));
                    Layers.CelebrationBackground.getSprite('DO_glow').visible = false;
                    Layers.CelebrationBackground.getSprite('filter').visible = false;
                    PortraitMessages.setFreespins();
                }),
            () => PosterTransition.end()
        ]);
    }
}



// WEBPACK FOOTER //
// ./src/transitions/enter-freespin-transition.ts